import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

import { IconName } from '../../icons-container/icons.type';
import { IconColorDirective, IconToken } from './directives/icon-color.directive';

export const IconSizes = {
  'small-xxx': 8,
  'small-xx': 12,
  'small-x': 16,
  small: 18,
  medium: 24,
  large: 32,
  'large-x': 48,
  'large-xx': 54,
};

export type IconSize = keyof typeof IconSizes;

@Component({
  standalone: true,
  selector: 'rt-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.icon]': 'true',
    '[class.has-auto-height]': 'hasAutoHeight',
  },
  hostDirectives: [
    {
      directive: IconColorDirective,
      // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
      inputs: ['iconColor: colorToken'],
    },
  ],
})
export class IconComponent implements OnChanges {
  @Input() public name: IconName = 'information';
  @Input() public hasAutoHeight: boolean = false;
  @Input() public colorToken: IconToken = <IconToken>'colorIconDefault';

  @Input()
  public set size(value: IconSize) {
    const size = IconSizes[value];
    if (!size) {
      throw new Error(`Invalid icon size [icon name: ${this.name}, size: ${value}]`);
    }
    this.sizeInPx = `${size}px`;
  }

  public svgName: string = `#${this.name}`;
  public sizeInPx: string = `${IconSizes['small']}px`;

  constructor(private renderer: Renderer2, public elementRef: ElementRef) {}

  public ngOnChanges(simpleChanges: SimpleChanges): void {
    if (simpleChanges.name) {
      const { previousValue, currentValue } = simpleChanges.name;
      if (previousValue) {
        this.renderer.removeClass(this.elementRef.nativeElement, `icon--${previousValue}`);
      }
      this.renderer.addClass(this.elementRef.nativeElement, `icon--${currentValue}`);
      this.svgName = `#${currentValue}`;
    }
  }
}
